<script lang="ts">
    import {pushPopupEvent} from 'general/libs/pushDataLayer';
    import {modal} from 'general/store';

    import s from './style.module.css';

    export let type: 'submit' | 'button' | 'reset' | 'quiz' | 'link' = 'button';
    export let color: 'dark' | 'mine-shaft' | 'blue' | 'blue-gradient' = 'dark';
    export let size: 'smaller' | 'small' | 'medium' | 'preLarge' | 'large' = 'medium';
    export let children = '';
    export let rounded = false;
    export let pointer = true;
    export let marginTop = '';
    export let marginBottom = '';
    export let href = '';
    export let disabled = false;
    export let onClick: () => void;
    export let eventLabel = '';
    export let isInteraction = false;
    export let smallerPadding = false;
    export let width = '';
</script>

{#if type === 'quiz' || type === 'link'}
    <a
        {href}
        on:click={() => {
            pushPopupEvent(eventLabel || `${children} CTA`, {}, isInteraction);
            modal.changeRedirect('');
            onClick();
        }}
        class="{s.button} {s[color] || ''} {s[size] || ''}"
        class:s.link={type === 'link'}
        class:s.rounded={rounded}
        class:s.pointer={pointer}
        class:s.smallerPadding={smallerPadding}
        style="margin-top: {marginTop}; margin-bottom: {marginBottom}"
    >
        {children}
    </a>
{:else}
    <button
        {disabled}
        {type}
        on:click={onClick}
        class="{s.button} {s[color] || ''} {s[size] || ''}"
        class:s.rounded={rounded}
        class:s.pointer={pointer}
        style="margin-top: {marginTop}; margin-bottom: {marginBottom}; width: {width}"
    >
        {children}
    </button>
{/if}
